// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ikx1","delete":"styles_delete__1ZT2X","update":"styles_update__23Zxk","add":"styles_add__1irZI"};